import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';

export const getStudentEnrollmentDetails = (studentsSchedulingDetails: StudentSchedulingDetails[], studentId: number, enrollmentId: number) =>
  studentsSchedulingDetails?.find((student) => student.id === studentId)?.enrollments.find((enrollment) => enrollment.id === enrollmentId);
